<template>
    <div class="xc-btn-select">
        <div class="xc-select-header">
            <div class="xc-header-left">{{title}}</div>
            <div class="xc-header-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHBAMAAADOnLEXAAAAMFBMVEUAAAB5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXmjbYbvAAAAEHRSTlMA/u/jLEHTv6lwVh0cEAc+S+p1PQAAADdJREFUCNdjiGEAgvMMwg4MDCyGDIqqDAxBQgzOggu4BE0YuBMlJ4ptYGC4LihYC1TF1yjxgAEAsDIIenYClwcAAAAASUVORK5CYII=">
            </div>
        </div>

        <!-- :class="{hide:isHide}" -->
        <!-- @click="close" -->
        <div class="xc-select-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
// function close(e) {
//     e.stopPropagation();
//     var _self = this.$el;
//     for (let i = 0; i < e.path.length; i++) {
//         const item = e.path[i];
//         /* if (item.className && item.className.indexOf('xc-btn-select') != -1) {
//              return;
//          }*/
//         if (item == _self) {
//             return;
//         }
//     }
//     this.close();
// }

export default {
    name: "XcBtnSelect",
    data() {
        return {
            isHide: true,
        }
    },
    props: {
        title: {
            type: String,
            default: "操作"
        },
    },
    methods: {
        // //打开下拉
        // open: function () {
        //     this.isHide = false
        // },
        // // 关闭下拉
        // close: function () {
        //     this.isHide = true;
        // },
    },
    created() {
        // var _this=this;
        // //    添加监听器
        // document.addEventListener("click", close.bind(_this))

    }
}
</script>

<style scoped lang="scss">
.xc-select-body {
    display: none;
}

.xc-btn-select {
    min-width: 75px;
    &:hover {
        .xc-select-body {
            display: block;
        }
    }
}
</style>
